import React from "react";
import styled from "styled-components";

const AboutContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 50px;
  background-color: #f9f9f9;
  min-height: 100vh;
`;

const Headline = styled.h1`
  font-size: 2.5rem;
  color: #2c3e50;
  margin-bottom: 20px;
`;

const BodyText = styled.p`
  font-size: 1.2rem;
  color: #7f8c8d;
  max-width: 800px;
  line-height: 1.6;
`;

const AboutUs = () => {
  return (
    <AboutContainer>
      <Headline>Our Mission: Transforming Loneliness into Connection</Headline>
      <BodyText>
        At Sophie, we believe that no one should feel alone, especially our elderly loved ones. Inspired by a personal story of love and care, Sophie was created to bring meaningful companionship to seniors through personalized daily phone calls. Our technology fosters connection, reduces loneliness, and promotes cognitive engagement, while keeping families and caregivers informed and connected.
        <br /><br />
        Our team is dedicated to improving the lives of seniors worldwide by combining compassionate technology with innovative solutions for caregiving.
      </BodyText>
    </AboutContainer>
  );
};

export default AboutUs;
